import {SmartComponent} from "smart-component-js";

class QuizComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.startScreen = this.element.querySelector('.quiz-start-screen');
        this.close = this.element.querySelector('.exit-btn');

        this.init();
    }

    addFormErrorListener() {
        document.addEventListener('yxp-form-config-error-require-logged-user', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-not-authorized', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-date-not-valid', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-already-answered', () => this.showFormError());
        document.addEventListener('yxp-form-config-error', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-not-found', () => this.showFormError());
    }

    showFormError() {
        this.startScreen.remove();
        this.element.querySelector('.yxpType_FORM').classList.add('form-visible');
        this.element.classList.remove('yxpLoading');
    }

    addStartListener() {
        const startButton = this.startScreen.querySelector('.yxpType_LINK a');
        this.startScreen.classList.add('visible');
        this.element.classList.remove('yxpLoading');
        if (!startButton) {
            this.element.querySelector('.yxpType_FORM').classList.add('form-visible');
            return;
        }
        startButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.startScreen.classList.remove('visible');
            setTimeout(() => {
                this.startScreen.remove();
                this.element.querySelector('.yxpType_FORM').classList.add('form-visible');
            }, 300);
        });

    }


    init() {
        this.element.classList.add('yxpLoading');
        this.addFormErrorListener();
        document.addEventListener('yxp-form-loaded', () => this.addStartListener());
    }
}

export default QuizComponent;